import React, { useEffect, useRef, useCallback, useState } from 'react';
import { getNotificationMeta } from '../../utils/notificationMeta';

export interface ToastItem {
  id: string;
  typeId: number;
  title: string;
  message: string;
}

interface NotificationToastContainerProps {
  toasts: ToastItem[];
  onDismiss: (id: string) => void;
}

function SingleToast({ toast, onDismiss }: { toast: ToastItem; onDismiss: (id: string) => void }) {
  const timerRef = useRef<ReturnType<typeof setTimeout>>();
  const [visible, setVisible] = useState(false);
  const meta = getNotificationMeta(toast.typeId);

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
    timerRef.current = setTimeout(() => onDismiss(toast.id), 5000);
    return () => clearTimeout(timerRef.current);
  }, [toast.id, onDismiss]);

  const handleClose = useCallback(() => {
    clearTimeout(timerRef.current);
    setVisible(false);
    setTimeout(() => onDismiss(toast.id), 300);
  }, [toast.id, onDismiss]);

  return (
    <div
      className={`toast show border-0 shadow-lg mb-2 ${visible ? 'opacity-100' : 'opacity-0'}`}
      role="alert"
      style={{ transition: 'opacity 0.3s ease', minWidth: 320 }}
    >
      <div className={`toast-header ${meta.bgColor} text-white`}>
        <i className={`fas fa-${meta.icon} me-2`} />
        <strong className="me-auto">{toast.title}</strong>
        <button
          type="button"
          className="btn-close btn-close-white"
          onClick={handleClose}
          aria-label="Kapat"
        />
      </div>
      <div className="toast-body">{toast.message}</div>
    </div>
  );
}

const NotificationToastContainer: React.FC<NotificationToastContainerProps> = ({
  toasts,
  onDismiss,
}) => {
  if (toasts.length === 0) return null;

  return (
    <div
      className="position-fixed top-0 end-0 p-3"
      style={{ zIndex: 1090 }}
    >
      {toasts.map((t) => (
        <SingleToast key={t.id} toast={t} onDismiss={onDismiss} />
      ))}
    </div>
  );
};

export default NotificationToastContainer;
